// Nederlandse vertalingen — primaire taal voor Todoes
// Nieuwe sleutels toevoegen in dezelfde stap als het component dat ze gebruikt.
const nl = {
  // =============================================
  // Algemeen / UI
  // =============================================
  'app.loading': 'Pagina laden...',
  'error.occurred': 'Er ging iets mis',

  // =============================================
  // TaskModal (pre-existing keys, ontbraken sinds Taak 5.1)
  // =============================================
  'modal.close': 'Sluiten',

  // =============================================
  // ErrorBoundary
  // =============================================
  'errorboundary.title': 'Er ging iets mis.',
  'errorboundary.description': 'De app liep vast op een onverwachte fout.',
  'errorboundary.reload': 'Herlaad applicatie',

  // =============================================
  // Confirm Dialog (Taak 0.5)
  // =============================================
  'confirm.delete.title': 'Taak verwijderen?',
  'confirm.delete.body':
    'Weet je zeker dat je deze taak en alle subtaken wilt verwijderen? Dit kan niet ongedaan worden gemaakt.',
  'confirm.cancel': 'Annuleren',
  'confirm.delete': 'Verwijderen',

  // =============================================
  // Wall modal (Free-tier limits)
  // =============================================
  'wall.project_limit.title': 'Meer projecten met Lite',
  'wall.project_limit.body':
    'Je hebt het maximum aantal actieve projecten voor Free bereikt. Met Lite werk je zonder limiet.',
  'wall.gcal_locked.title': 'Agenda-sync is een Lite-functie',
  'wall.gcal_locked.body':
    'Koppel je Google Agenda en zie alles in één overzicht — beschikbaar met Lite.',
  'wall.dashboard_scroll.title': 'Meer geschiedenis met Lite',
  'wall.dashboard_scroll.body':
    'Bekijk je volledige voortgang terug — Free toont de laatste week.',
  'wall.understood': 'Begrepen',
  'wall.registerInterest': 'Informeer me wanneer beschikbaar',
  'wall.interestThankYou': 'Bedankt. Je hoort het zodra het er is.',

  // =============================================
  // Quick Bar / GoBar (Taak 0.3)
  // =============================================
  'quickbar.placeholder':
    'Nieuwe taak... #project @context ~duur +persoon >datum',
  'gobar.placeholder': 'Zoek of navigeer...',

  // =============================================
  // Focus Task (Taak 0.4)
  // =============================================
  'focus.start': 'Start focus',
  'focus.stop': 'Stop focus',
  'focus.pause': 'Pauzeer',
  'focus.inProgress': 'Nu bezig',
  'focus.complete': 'Taak voltooien',

  // =============================================
  // Onboarding (script scene 2)
  // =============================================
  'onboarding.hint.dismiss': 'Begrepen',
  'onboarding.focusHint.body':
    'Start focus op de taak waar je nu aan begint.',
  'onboarding.focusHint.dismiss': 'Sluiten',
  'onboarding.nextActionPanel.body':
    'Hier staat de eerstvolgende stap van taken die je hebt opgesplitst.',
  'onboarding.nextActionPanel.dismiss': 'Sluiten',
  'onboarding.triageHint.title': 'Sommige taken missen nog details.',
  'onboarding.triageHint.body':
    'Klik op dit blok om ze in de Inbox aan te vullen.',
  'onboarding.quickAddHint.body':
    'Tip: typ bijvoorbeeld «{example}». Druk op {shortcut} om hier te typen. Dezelfde syntax werkt in de snel-toevoegbalk en bij inline bewerken. Meer onder Help.',
  'onboarding.quickAddHint.dismiss': 'Sluiten',

  'activationnotice.completedSingular':
    '{count} taak voltooid sinds je begon. Goed op weg!',
  'activationnotice.completedPlural':
    '{count} taken voltooid sinds je begon. Goed op weg!',
  'activationnotice.dismiss': 'Sluiten',

  // =============================================
  // Shared UI components
  // =============================================
  'shared.addTask': 'Taak toevoegen',

  // =============================================
  // Today Page (Epic 1)
  // =============================================
  'today.triage': 'Inbox',
  'today.triage.time': 'Standaardduur',
  'today.triage.context': 'Context',
  'today.triage.project': 'Project',
  'dayprogressdots.of': 'van',

  // =============================================
  // Plan Page (Epic 2)
  // =============================================
  'plan.title': 'Planning',
  'plan.day': 'Dag',
  'plan.week': 'Week',
  'plan.month': 'Maand',
  'weekdaycell.morning': 'Ochtend',
  'weekdaycell.afternoon': 'Middag',
  'weekdaycell.evening': 'Avond',

  // =============================================
  // Organize Page (Epic 3)
  // =============================================
  'organize.title': 'Ordenen', // tests/auth.spec.js /Organize|Ordenen/i
  'organize.tabActive': 'Actief',
  'organize.tabBacklog': 'Backlog',
  'organize.tabInbox': 'Inbox',
  'organize.selectTask': 'Selecteer een taak om details te zien',
  'organize.noTasks': 'Geen taken binnen deze filters.',
  'organize.emptyBacklog': 'Niets in Backlog.',
  'organize.emptyActive': 'Geen actieve taken.',
  'organize.noSubtasks': 'Sleep een taak hierheen',
  'organize.editTask': 'Taak bewerken',
  'organize.confirmMoveWithDescendants':
    'Deze taak heeft {count} subtaken. Weet je zeker dat je hem wilt verplaatsen?',
  'inboxview.duration': 'Standaardduur',
  'inboxview.missingProject': 'Geen project',
  'inboxview.missingContext': 'Geen context',
  'inboxview.newContextPlaceholder': 'Nieuwe context, bijv. @thuis',
  'inboxview.newProjectPlaceholder': 'Nieuw project, bijv. #werk',
  'inboxview.selectGroup': 'Selecteer een triagegroep om dropzones te tonen',
  'inboxdropzone.dropHint': 'Sleep een taak hierheen',
  'inboxdropzone.zoneAriaLabel': 'Dropzone {label}',
  'inboxdropzone.assignedAnnouncement': 'Taak toegewezen aan {label}',
  'inboxdropzones.toolbarLabel': 'Geselecteerde taak aan een dropzone toewijzen',
  'inboxpage.empty': 'Je Inbox is leeg.',

  // =============================================
  // Dashboard Page (Epic 4)
  // =============================================
  'dashboard.title': 'Dashboard',
  'dashboard.completed': 'Voltooid',
  'dashboard.waiting': 'Wachtend',
  'dashboard.noCompleted': 'Geen voltooide taken binnen deze filters.',
  'dashboard.noWaiting': 'Geen gedelegeerde taken binnen deze filters.',
  'dashboard.totalHours': 'voltooid deze week',
  'dashboard.totalTasks': 'taken voltooid',
  'dashboard.delta': 't.o.v. vorige week',
  'dashboard.activeDays': 'actieve dagen',
  'dashboard.bestDay': 'beste dag',
  'dashboard.biggestTask': 'grootste taak — {meta}',
  'dashboard.biggestTaskShort': 'grootste taak',
  'dashboard.projectBreakdownBars': 'Projectbalken',
  'dashboard.previousWeek': 'Vorige week',
  'dashboard.nextWeek': 'Volgende week',
  'dashboard.weeklyChart': 'Uren per dag',
  'dashboard.weeklyChartLegend': 'Projecten in deze week',
  'dashboard.weeklyChartBars': 'Dagbalken',
  'dashboard.projectTimeThisWeek': 'Tijd per project — deze week',

  // Relative date labels (planning / dashboard)
  'dates.yesterday': 'Gisteren',
  'dates.dayAfterTomorrow': 'Overmorgen',

  // =============================================
  // TaskItemBase (render helpers)
  // =============================================
  'taskitem.mainTask': 'Hoofdtaak',
  'taskitem.deleteTask': 'Taak verwijderen',
  'taskitem.listPosition': '{title}, taak {current} van {total}',
  'taskitem.overdueByDays': '{days}d te laat',
  'taskitem.addSubtask': 'Subtaak toevoegen',

  // =============================================
  // Task context menu (right-click)
  // =============================================
  'contextMenu.assign': 'Wachten op…',
  'contextMenu.delete': 'Verwijderen',
  'contextMenu.addSubtask': 'Subtaak toevoegen',
  'contextMenu.moveToTomorrow': 'Verplaats naar morgen',
  'contextMenu.moveToToday': 'Verplaats naar vandaag',
  'contextMenu.moveToBacklog': 'Naar Backlog',
  'contextMenu.moveToActive': 'Naar Actief',
  'contextMenu.clearAssignee': 'Niet meer wachten',

  // =============================================
  // Login / Logout / ProtectedRoute
  // =============================================
  'login.title': 'Welkom bij Riposo', // tests/auth.spec.js accepteert NL of EN
  'login.googleSignIn': 'Inloggen met Google',
  'login.googleSignUp': 'Registreren met Google',
  'login.testUser': 'Testgebruiker aanmelden (alleen test)',
  'login.or': 'of',
  'login.tabsLabel': 'Inloggen met e-mail',
  'login.tabSignIn': 'Inloggen',
  'login.tabSignUp': 'Registreren',
  'login.emailLabel': 'E-mailadres',
  'login.passwordLabel': 'Wachtwoord',
  'login.passwordConfirmLabel': 'Wachtwoord bevestigen',
  'login.showPassword': 'Wachtwoord tonen',
  'login.hidePassword': 'Wachtwoord verbergen',
  'login.submitting': 'Even geduld…',
  'login.forgotPassword': 'Wachtwoord vergeten?',
  'login.resetSend': 'Stuur resetlink',
  'login.resetBackToSignIn': 'Terug naar inloggen',
  'login.resetSuccess': 'Als dit adres bestaat, sturen we een link.',
  'login.resetCooldown': 'Opnieuw versturen over {seconds}s',
  'login.passwordStrength.weak': 'Zwak',
  'login.passwordStrength.fair': 'Redelijk',
  'login.passwordStrength.strong': 'Sterk',
  'auth.error.emailAlreadyInUse': 'Dit e-mailadres is al geregistreerd.',
  'auth.error.emailLinkedToGoogle': 'Dit adres is al gekoppeld aan Google. Log in met Google.',
  'auth.error.emailHasPasswordAccount': 'Dit adres heeft al een account. Log in.',
  'auth.error.emailSignUpConflictGeneric':
    'Kan niet registreren met dit adres. Probeer in te loggen of gebruik een andere methode.',
  'auth.error.googleUsePassword':
    'Dit e-mailadres heeft al een wachtwoord-account. Log in met e-mail en wachtwoord.',
  'auth.error.weakPassword': 'Wachtwoord is te zwak. Gebruik minimaal 8 tekens.',
  'auth.error.invalidEmail': 'Vul een geldig e-mailadres in.',
  'auth.error.invalidCredentials': 'Onjuist e-mailadres of wachtwoord.',
  'auth.error.tooManyRequests': 'Te veel pogingen. Probeer het later opnieuw.',
  'auth.error.network': 'Netwerkfout. Controleer je verbinding en probeer het opnieuw.',
  'auth.error.unknown': 'Er ging iets mis. Probeer het opnieuw.',
  'auth.error.emptyEmail': 'Vul je e-mailadres in.',
  'auth.error.emptyPassword': 'Vul je wachtwoord in.',
  'auth.emailVerification.message': 'Bevestig je e-mailadres',
  'auth.emailVerification.resend': 'Mail opnieuw sturen',
  'auth.emailVerification.dismiss': 'Sluiten',
  'consent.analytics.message':
    'We gebruiken analytics-cookies om te begrijpen hoe Todoes wordt gebruikt. Je kunt accepteren of weigeren.',
  'consent.analytics.accept': 'Accepteren',
  'consent.analytics.reject': 'Weigeren',
  'auth.validation.passwordMismatch': 'Wachtwoorden komen niet overeen.',
  'logout.loading': 'Bezig met afmelden...',
  'common.loading': 'Laden...',

  // =============================================
  // Task / Organize
  // =============================================
  'task.noDescription': 'Geen beschrijving',
  'task.date': 'Datum:',
  'task.time': 'Tijd:',
  'task.showMore': 'Meer weergeven',
  'task.showLess': 'Minder weergeven',

  // =============================================
  // Today Page
  // =============================================
  'todaypage.title': 'Vandaag',
  'completionstreak.day': 'dag op rij',
  'completionstreak.days': 'dagen op rij',

  // =============================================
  // Common (gedeeld tussen componenten)
  // =============================================
  'common.minutesShort': 'm',

  // =============================================
  // Planning (Horizon/Plan panels, PlanPage)
  // =============================================
  'plan.unscheduled': 'Te plannen',
  'plan.partiallyScheduled': '{done} van {total} ingepland',
  'plan.overdue': 'Herplannen',
  'plan.nextAction': 'Volgende acties',
  'plan.agenda': 'Agenda',
  'plan.agendaShow': 'Agenda tonen',
  'plan.agendaHide': 'Agenda verbergen',
  'plan.agendaLocked': 'Google Calendar-sync (Lite-functie)',
  'plan.planMode': 'Planmodus',
  'plan.planModeShow': 'Planmodus aanzetten',
  'plan.planModeHide': 'Planmodus uitzetten',
  'plan.weekRegion': 'Weekoverzicht',
  'plan.monthRegion': 'Maandoverzicht',
  'plan.planModeNeedsProject': 'Kies één project om te plannen.',
  'plan.planModeRailTitle': 'Plan',
  'plan.calendarRegion': 'Dagkalender',
  'plan.calendarKeyboardHint':
    'Navigeer met de pijltjestoetsen door je geplande taken.',
  'planpage.accessDenied': 'Geen toegang. Je wordt afgemeld.',
  'planpage.noMetadata': 'taken zonder metadata',
  'planpage.waitingOnSomeone': 'wacht op iemand',

  // =============================================
  // GoBarModal
  // =============================================
  'gobar.noResults': 'Geen taken gevonden',
  'gobar.filterCommand': '→ Ordenen: toon alleen {tags}',
  'gobar.createTask': 'Nieuwe taak: "{query}"',
  'gobar.keyboardHint': '↑↓ navigeren · Enter selecteren · Esc sluiten',

  // =============================================
  // LiveFocusTimer / TaskCheckbox / TaskExecutionActions / TaskMetadata
  // =============================================
  'livefocustimer.title': 'Focus-timer',
  'taskcheckbox.markComplete': 'Markeer als voltooid',
  'taskmetadata.fixOrder': 'Volgorde herstellen',
  'taskmetadata.dueDate': 'Deadline',

  // =============================================
  // TaskForm
  // =============================================
  'taskform.deleteTask': 'taak verwijderen',
  'taskform.titleLabel': 'Titel:',
  'taskform.titlePlaceholder': 'Taaktitel',
  'taskform.backlog': 'Backlog',
  'taskform.backlogHint':
    'Staat niet in de actieve planning tot je de taak weer actief maakt.',
  'taskform.subtasks': 'Subtaken',
  'taskform.editTitle': 'Titel bewerken',
  // 'Active'/'Backlog' zijn de letterlijke task.status enum-waarden (datamodel, staan in
  // value= en blijven Engels). Alleen het label 'Active' is vertaald (Actief); 'Backlog'
  // blijft: tests/bulk-edit.spec.js selecteert de optie op exact die tekst.
  'taskform.statusActive': 'Actief',
  'taskform.statusBacklog': 'Backlog',
  'taskform.description': 'Beschrijving',
  'taskform.parentLabel': 'Bovenliggende taak',
  'taskform.addTag': '+ toevoegen',
  'taskform.addProject': 'Project toevoegen',
  'taskform.addContext': 'Context toevoegen',
  'taskform.addPerson': 'Wachten op…',
  'taskform.changeParent': 'Bovenliggende taak wijzigen',
  'taskform.cancel': 'Annuleren',
  'taskform.saveChanges': 'Wijzigingen opslaan',
  'taskform.addTask': 'Taak opslaan',

  // =============================================
  // TaskDescriptionEditor (Epic 6 Taak 0.4)
  // =============================================
  'taskdescriptioneditor.noDescription':
    'Geen beschrijving — klik om toe te voegen',
  'taskdescriptioneditor.placeholder': 'Geen beschrijving',

  // =============================================
  // TaskInputInline
  // =============================================
  'taskinputinline.placeholder': 'Nieuwe subtaak (#project @context)...',

  // =============================================
  // TaskDateTimeFields
  // =============================================
  'taskdatetimefields.repeatEvery': 'Herhaal elke',
  'taskdatetimefields.period': 'Periode',
  'taskdatetimefields.days': 'Dagen',
  'taskdatetimefields.weeks': 'Weken',
  'taskdatetimefields.months': 'Maanden',
  'taskdatetimefields.date': 'Datum',
  'taskdatetimefields.time': 'Tijd',
  'taskdatetimefields.duration': 'Duur',
  'taskdatetimefields.toggleRecurrence': 'herhaling aan/uit',

  // =============================================
  // TaskParentSelector
  // =============================================
  'taskparentselector.placeholder': 'Kies bovenliggende taak',

  // =============================================
  // TaskTagFields
  // =============================================
  'tasktagfields.projectPlaceholder': 'Voeg project toe of selecteer',
  'tasktagfields.contextsPlaceholder': 'Voeg context toe of selecteer',
  'tasktagfields.personPlaceholder': 'Wachten op…',

  // =============================================
  // TaskItemBase / TaskItemSwipeable
  // =============================================
  'taskitembase.invalidTask': '[Ongeldige taak]',
  'taskitemswipeable.complete': 'Voltooien',
  'taskitemswipeable.snoozeToday': 'Vandaag',
  'taskitemswipeable.snoozeTomorrow': 'Morgen',
  'taskitemmobilesortable.dragToReorder': 'Sleep om te herordenen',

  // =============================================
  // TaskBulkEditModal
  // =============================================
  'taskbulkeditmodal.setDate': 'Datum instellen',
  'taskbulkeditmodal.duration': 'Duur',
  'taskbulkeditmodal.durationInvalid':
    'Ongeldige duur, probeer bijvoorbeeld 30m, 1h of 1u30',
  'taskbulkeditmodal.setStatus': 'Status instellen',
  'taskbulkeditmodal.noChange': 'Niet wijzigen',
  'taskbulkeditmodal.setProject': 'Project instellen',
  'taskbulkeditmodal.clearProject': 'Project leegmaken',
  'taskbulkeditmodal.setContext': 'Context instellen',
  'taskbulkeditmodal.clearContext': 'Context leegmaken',
  'taskbulkeditmodal.setPerson': 'Wachten op instellen',
  'taskbulkeditmodal.title': '{count} taken bewerken',
  'taskbulkeditmodal.cancel': 'Annuleren',
  'taskbulkeditmodal.applyChanges': 'Wijzigingen opslaan',
  'taskbulkeditmodal.clearFieldShort': 'Leegmaken',
  'taskbulkeditmodal.resetField': 'Terugzetten',

  // =============================================
  // TaskGroup* (Next Actions/Overdue/Subtasks/Upcoming)
  // =============================================
  'taskgroupsubtasks.title': 'Subtaken',

  // =============================================
  // Today: acties-menus / content / triage / bulk actions
  // =============================================
  'bulkactionbar.selected': 'geselecteerd',
  'bulkactionbar.moveToToday': 'Verplaats naar vandaag',
  'bulkactionbar.completeAll': 'Alles voltooien',
  'bulkactionbar.clearDates': 'Datums wissen',
  'bulkactionbar.cancel': 'Annuleren',
  'todayviewcontent.overdue': 'Herplannen',
  'todayviewcontent.today': 'Vandaag',
  'todayviewcontent.nextActions': 'Volgende acties',
  'todayviewcontent.upcomingTasks': 'Geplande taken',
  'todayviewcontent.upcomingEmpty': 'Geen geplande taken.',
  'todayviewcontent.completed': 'Voltooid',
  'todayviewcontent.appointments': 'Afspraken',
  'todayviewcontent.appointmentUntitled': '(Geen titel)',
  'todayviewcontent.deadlines': 'Deadlines',
  'todayviewcontent.todayInProgress': 'Je bent bezig met je taak voor vandaag.',
  'todayviewcontent.todayEmpty': 'Geen openstaande taken voor vandaag! 🎉',
  'todayviewcontent.nextActionInProgress':
    'Je bent bezig met je volgende actie.',
  'todayviewcontent.nextActionsEmpty': 'Geen volgende acties.',
  'todayviewcontent.todayNoTasksEver': 'Begin met één taak.',
  'todayviewcontent.addTaskToday': 'Taak voor vandaag toevoegen',
  'todayviewcontent.todayNothingPlanned': 'Niets gepland voor vandaag.',
  // Waarden bewust ongewijzigd: tests/triage.spec.js selecteert
  // h3-elementen op deze exacte tekst ('Inbox'/'10 min'/'1 uur'/'4 uur').
  'triageboard.small': '10m',
  'triageboard.medium': '1h',
  'triageboard.large': '4h',

  // =============================================
  // English-locale sweep (Taak: English locale support)
  // =============================================
  'taskform.noSubtasks': 'Nog geen subtaken.',
  'taskinputquick.addError': 'Taak toevoegen lukte niet. Probeer het opnieuw.',
  'taskinputquick.addTask': 'Taak toevoegen',
  'taskinputquick.createDetailedTask': 'Gedetailleerde taak aanmaken',
  'taskdetailmetadata.rollupDuration': 'Berekende duur (som van subtaken)',
  'taskdetailmetadata.estimatedDuration': 'Geschatte duur',
  'taskexecutionactions.subtaskProgress': 'subtaken voltooid',
  'taskform.rootParent': 'Hoofdniveau',
  'taskform.rootParentHint': 'Deze taak heeft geen bovenliggende taak.',
  'useTaskActions.followUpError': 'Vervolgtaak inplannen lukte niet.',
  'taskmetrics.noProject': 'Geen project',
  'filterbar.all': 'Alles',
  'filterbar.toolbar': 'Taakfilters',
  'appbar.devTierSwitch': 'Dev: tier →',
  'appbar.logoAlt': 'Riposo',
  'appbar.filter': 'Filter',
  'appbar.inbox': 'Inbox',
  'appbar.logout': 'Afmelden',
  'appbar.feedback': 'Feedback',
  'appbar.accountMenu': 'Accountmenu',
  'appbar.navMenu': 'Navigatiemenu',
  'help.menuItem': 'Help',
  'settings.menuItem': 'Instellingen',
  'settings.title': 'Instellingen',
  'settings.close': 'Instellingen sluiten',
  'settings.account.title': 'Account',
  'settings.account.displayName.label': 'Je naam',
  'settings.account.displayName.save': 'Naam opslaan',
  'settings.account.displayName.errorEmpty': 'Vul een naam in om op te slaan.',
  'settings.account.displayName.errorTooLong': 'Gebruik maximaal 50 tekens.',
  'settings.account.displayName.errorSave':
    'Je naam kon niet worden opgeslagen. Probeer het opnieuw.',
  'settings.account.signInMethod.title': 'Inlogmethode',
  'settings.account.signInMethod.google': 'Google',
  'settings.account.signInMethod.password': 'E-mail en wachtwoord',
  'settings.account.signInMethod.unknown': 'Onbekend',
  'settings.account.signInMethod.emailVerified': 'Bevestigd',
  'settings.account.signInMethod.emailUnverified': 'Nog niet bevestigd',
  'settings.account.marketing.label': 'Nieuws en updates over Riposo',
  'settings.account.marketing.description':
    'Af en toe productnieuws. Je kunt dit altijd uitzetten.',
  'settings.account.marketing.errorSave':
    'Marketingvoorkeur kon niet worden bijgewerkt. Probeer het opnieuw.',
  'settings.account.delete.button': 'Account verwijderen',
  'settings.account.delete.reauthTitle': 'Bevestig je wachtwoord',
  'settings.account.delete.reauthBody':
    'Voer je wachtwoord opnieuw in voordat je je account kunt verwijderen.',
  'settings.account.delete.reauthPasswordLabel': 'Wachtwoord',
  'settings.account.delete.reauthContinue': 'Doorgaan',
  'settings.account.delete.confirmTitle': 'Account definitief verwijderen?',
  'settings.account.delete.confirmBody':
    'Hiermee verwijder je je taken en accountdata. Typ je e-mailadres ter bevestiging.',
  'settings.account.delete.confirmEmailLabel': 'Je e-mailadres',
  'settings.account.delete.confirmAction': 'Account verwijderen',
  'settings.account.delete.errorEmailMismatch':
    'Het e-mailadres komt niet overeen met je account.',
  'settings.account.delete.errorData':
    'Je data kon niet worden verwijderd. Controleer je verbinding en probeer het opnieuw.',
  'settings.account.delete.errorAuthUserRemains':
    'Je data is verwijderd, maar afmelden bij je login is mislukt. Log opnieuw in en herhaal het verwijderen van je account.',
  'login.accountDeleted':
    'Je account is verwijderd. Je kunt een nieuw account aanmaken door opnieuw in te loggen.',
  'settings.language.title': 'Taal',
  'settings.language.ariaLabel': 'App-taal',
  'settings.language.option.nl': 'Nederlands',
  'settings.language.option.en': 'English',
  'help.title': 'Help',
  'help.close': 'Sluiten',
  'help.shortcuts.title': 'Sneltoetsen',
  'help.shortcuts.intro': 'Werk sneller zonder muis.',
  'help.shortcuts.more': 'Meer sneltoetsen',
  'help.shortcuts.group.global': 'Overal',
  'help.shortcuts.group.list': 'Taaklijst (lijst gefocust, geen invoerveld)',
  'help.shortcuts.group.input': 'Invoerveld',
  'help.shortcuts.group.other': 'Overig',
  'help.shortcuts.footnote.structuralNav':
    'Inspringen en uitspringen werken niet in platte lijsten (o.a. Plan-panelen, Inbox, wachtlijst). Tab is niet gebonden; gebruik Ctrl+] en Ctrl+[.',
  'help.shortcuts.quickAdd': 'Focus op snel toevoegen',
  'help.shortcuts.goBar': 'Zoeken en commando’s (GoBar)',
  'help.shortcuts.pageNav': 'Naar Vandaag, Plan, Ordenen of Dashboard',
  'help.shortcuts.listSelect': 'Taak selecteren',
  'help.shortcuts.listEdit': 'Taak hernoemen (inline)',
  'help.shortcuts.listComplete': 'Taak voltooien of terugzetten',
  'help.shortcuts.listReorder': 'Taak verplaatsen in de lijst',
  'help.shortcuts.listAddAbove': 'Nieuwe taak boven de selectie',
  'help.shortcuts.listAddBelow': 'Nieuwe taak onder de selectie',
  'help.shortcuts.listAddSubtask': 'Subtaak toevoegen',
  'help.shortcuts.listIndent':
    'Taak inspringen (subtaak van vorige); niet in platte lijsten',
  'help.shortcuts.listOutdent':
    'Taak uitspringen; niet in platte lijsten',
  'help.shortcuts.listFollowUp': 'Follow-up plannen',
  'help.shortcuts.listFocus': 'Focus starten of stoppen',
  'help.shortcuts.listOpen': 'Taak openen (detail)',
  'help.shortcuts.listDelete': 'Taak verwijderen (met bevestiging)',
  'help.shortcuts.listClearSelection': 'Selectie opheffen',
  'help.shortcuts.inputSubmit': 'Taak toevoegen of wijziging bevestigen',
  'help.shortcuts.inputCancel': 'Annuleren of veld leegmaken',
  'help.shortcuts.goBarNav': 'Resultaat kiezen of GoBar sluiten',
  'help.shortcuts.calendarTaskNav': 'Tussen geplande taken in de kalender',
  'help.shortcuts.organizeBulkEdit':
    'Bulk-bewerken openen bij meerdere geselecteerde taken',
  'help.shortcuts.mouseMultiSelect': 'Taken (de)selecteren in een lijst',
  'help.shortcuts.dashboardBarNav': 'Dashboard-grafieken: item kiezen',
  'help.shortcuts.filterBarNav': 'Filterbalk: filter kiezen',
  'help.shortcuts.keys.quickAdd': 'n',
  'help.shortcuts.keys.goBar': 'Ctrl+K',
  'help.shortcuts.keys.goBarMac': '⌘K',
  'help.shortcuts.keys.pageNav': 'Alt+1 … Alt+4',
  'help.shortcuts.keys.listSelect': '↑ ↓',
  'help.shortcuts.keys.listEdit': 'F2',
  'help.shortcuts.keys.listComplete': 'Spatie',
  'help.shortcuts.keys.listReorder': 'Ctrl+↑ Ctrl+↓',
  'help.shortcuts.keys.listAddAbove': 'a',
  'help.shortcuts.keys.listAddBelow': 'b',
  'help.shortcuts.keys.listAddSubtask': 's',
  'help.shortcuts.keys.listIndent': 'Ctrl+]',
  'help.shortcuts.keys.listOutdent': 'Ctrl+[',
  'help.shortcuts.keys.listFollowUp': 'Ctrl+Spatie',
  'help.shortcuts.keys.listFocus': 'Ctrl+Enter',
  'help.shortcuts.keys.listOpen': 'Enter',
  'help.shortcuts.keys.listDelete': 'Delete',
  'help.shortcuts.keys.listClearSelection': 'Esc',
  'help.shortcuts.keys.inputSubmit': 'Enter',
  'help.shortcuts.keys.inputCancel': 'Esc',
  'help.shortcuts.keys.goBarNav': '↑ ↓ Enter Esc',
  'help.shortcuts.keys.calendarTaskNav': '← → ↑ ↓',
  'help.shortcuts.keys.organizeBulkEdit': 'Enter',
  'help.shortcuts.keys.mouseMultiSelect': 'Ctrl+klik, Shift+klik',
  'help.shortcuts.keys.dashboardBarNav': '← → Enter Spatie',
  'help.shortcuts.keys.filterBarNav': '← → Home End Enter Spatie',
  'help.shortcuts.col.key': 'Toets',
  'help.shortcuts.col.action': 'Actie',
  'help.quickbar.title': 'Snel invoeren',
  'help.quickbar.intro':
    'Typ deze tekens in een nieuwe taak om hem meteen op zijn plek te zetten.',
  'help.quickbar.col.token': 'Teken',
  'help.quickbar.col.meaning': 'Betekenis',
  'help.quickbar.col.example': 'Voorbeeld',
  'help.quickbar.row.project.meaning': 'Project: waar de taak bij hoort.',
  'help.quickbar.row.project.example': '#werk',
  'help.quickbar.row.context.meaning': 'Context: wanneer of waar je hem doet.',
  'help.quickbar.row.context.example': '@kantoor',
  'help.quickbar.row.duration.meaning':
    'Duur: hoe lang je erover denkt te doen. Bij ~ is m minuten; bij * is m maand.',
  'help.quickbar.row.duration.example': '~30m, ~1u, ~1h30',
  'help.quickbar.row.person.meaning': 'Persoon (één per taak).',
  'help.quickbar.row.person.example': '+jan',
  'help.quickbar.row.date.meaning': 'Planningsdatum.',
  'help.quickbar.row.date.example': '>morgen, >vrijdag, >vandaag',
  'help.quickbar.row.recurrence.meaning':
    'Herhaling: cijfer + d/w/m/j, of woorden zoals *wekelijks of *maandelijks.',
  'help.quickbar.row.recurrence.example': '*1m, *2w, *1d, *1j, *wekelijks',
  'help.quickbar.example': 'Offerte nakijken #werk @kantoor ~30m >vrijdag',
  'help.restartIntro.title': 'Intro opnieuw starten',
  'help.restartIntro.body':
    'Je loopt de intro opnieuw door en maakt daarbij opnieuw een taak aan.',
  'help.restartIntro.confirm': 'Opnieuw starten',
  'help.restartIntro.cancel': 'Annuleren',
  'onboarding.organizeIntro.title':
    'Hier werk je taken uit en breng je structuur aan.',
  'onboarding.organizeIntro.body':
    'Sleep taken om de volgorde te wijzigen (of gebruik Ctrl+↑↓). Selecteer een taak om rechts subtaken toe te voegen en details in te vullen.',
  'onboarding.backlogIntro.title':
    'Taken in de Backlog verdwijnen uit beeld tot je er weer tijd voor hebt.',
  'onboarding.backlogIntro.body': 'Je zet een taak erin via de taakdetails.',
  'onboarding.inboxIntro.title':
    'Hier vul je de details in van taken die nog niet compleet zijn.',
  'onboarding.inboxIntro.body':
    'Sleep een taak naar een duur, project of context. Zonder duur telt een taak 15 minuten.',
  'onboarding.contextIntro.title':
    'Context is waar of wanneer je iets doet, bijvoorbeeld @thuis of @onderweg.',
  'onboarding.contextIntro.body':
    'Maak hier een context aan of typ `@context` bij een taak. Daarna kun je taken hierheen slepen.',
  'a11y.skipToContent': 'Ga naar hoofdinhoud',

  // =============================================
  // Onboarding tour (/welcome)
  // =============================================
  'onboarding.tour.title': 'Van losse gedachte naar plan, in een minuut.',
  'onboarding.tour.skip': 'Intro overslaan',
  'onboarding.tour.progress': 'Stap {current} van {total}',
  'onboarding.displayNameStep.title': 'Hoe mag ik je noemen?',
  'onboarding.displayNameStep.body':
    'Een voornaam is genoeg — zo spreek ik je persoonlijk aan.',
  'onboarding.displayNameStep.label': 'Je naam',
  'onboarding.displayNameStep.submit': 'Verder',
  'onboarding.displayNameStep.errorEmpty':
    'Vul je naam in om verder te gaan.',
  'onboarding.displayNameStep.errorTooLong': 'Gebruik maximaal 50 tekens.',
  'onboarding.displayNameStep.errorSave':
    'Opslaan is mislukt. Probeer het opnieuw.',
  'onboarding.displayNameStep.marketingOptIn':
    'Houd me op de hoogte van nieuws en updates over Riposo.',
  'onboarding.taskStep.title': 'Wat houdt je bezig?',
  'onboarding.taskStep.body': 'Schrijf er één op. De rest komt zo.',
  'onboarding.taskStep.placeholder': 'Bijvoorbeeld: offerte afmaken',
  'onboarding.projectStep.title': 'Waar hoort dit bij?',
  'onboarding.projectStep.body':
    'Een project bundelt taken die bij elkaar horen, zoals een klant of een verhuizing. Je herkent ze aan de #: typ er één, bijvoorbeeld #werk.',
  'onboarding.projectStep.placeholder': '#werk',
  'onboarding.projectStep.submit': 'Volgende',
  'onboarding.subtaskStep.title': 'Wat is de eerste stap?',
  'onboarding.subtaskStep.body':
    'Begin met de eerste stap, dan is starten makkelijker.',
  'onboarding.subtaskStep.plusHint': 'Druk op + om een subtaak toe te voegen.',
  'onboarding.subtaskStep.placeholder': 'Bijvoorbeeld: cijfers opzoeken',
  'onboarding.subtaskStep.enterHint': 'Enter om toe te voegen',
  'onboarding.subtaskStep.skip': 'Overslaan',
  'onboarding.subtaskStep.done': 'Klaar',
  'onboarding.more.title': 'Nog meer op je lijst?',
  'onboarding.more.body': 'Voeg toe wat je wil, zo veel als je wil.',
  'onboarding.more.skip': 'Overslaan',
  'onboarding.more.done': 'Klaar',
  'onboarding.more.contextPrompt':
    'Wanneer of waar doe je dit? Zet er @thuis of @onderweg bij.',
  'onboarding.more.durationPrompt':
    'Hoe lang duurt dit ongeveer? Zet er `~30m` of `~1u` bij.',
  'onboarding.more.durationDefault':
    'Laat je hem leeg, dan geldt 15 minuten.',
  'onboarding.more.laterHint': 'Je kan dit altijd later aanvullen.',
  'onboarding.slot.dragHintFirstStep':
    'Dit is je Volgende actie, de eerste stap van je taak. Sleep hem naar een moment in je planning.',
  'onboarding.slot.dragHintTask':
    'Sleep je taak naar een moment in je planning.',
  'onboarding.slot.skip': 'Overslaan',
  'onboarding.slot.skipLaterHint': 'Je kan hem later inplannen.',
  'onboarding.duration.body':
    'Standaard duurt een taak 15 minuten. Sleep de onderrand om dat aan te passen.',
  'onboarding.duration.next': 'Volgende',
  'onboarding.outro.planned':
    'Mooi, je eerste stap staat in je planning.',
  'onboarding.outro.plannedWithMore':
    'Mooi, je eerste stap staat in je planning. De andere taken staan klaar in Te plannen: sleep ze erbij en vul je dag.',
  'onboarding.outro.unplanned':
    'Alles staat klaar in Te plannen: sleep een taak naar een moment en vul je dag.',
  'onboarding.outro.start': 'Aan de slag',
  'onboarding.outro.close': 'Sluiten',
  'onboarding.outro.helpHint':
    'Sneltoetsen en uitleg: klik rechtsboven op je initialen → Help.',

  // =============================================
  // PrivacyPage (tijdelijke /privacy route)
  // =============================================
  'privacy.langToggle.nl': 'Nederlands',
  'privacy.langToggle.en': 'English',
  'privacy.langToggle.groupLabel': 'Taal',
  'privacy.eyebrow': 'Concept — nog niet definitief',
  'privacy.title': 'Privacyverklaring Todoes',
  'privacy.updated': 'Laatst bijgewerkt: {date} · versie 0.2',
  'privacy.intro':
    'Dit overzicht beschrijft welke gegevens Todoes verzamelt, waarom, en wat je rechten zijn. Het is gebaseerd op hoe de app op dit moment werkelijk functioneert.',
  'privacy.placeholderNotice':
    'Bedrijfsgegevens (naam, KvK-nummer, adres, contact-e-mailadres) ontbreken nog — hieronder staan placeholders die vóór publicatie moeten worden ingevuld.',

  'privacy.section1.heading': '1. Wie is verantwoordelijk voor je gegevens',
  'privacy.section1.body':
    '[Bedrijfsnaam], gevestigd te [vestigingsplaats], KvK-nummer [KvK-nummer], is verantwoordelijk voor de verwerking van persoonsgegevens via Todoes. Vragen? Mail [contact-e-mailadres].',

  'privacy.section2.heading': '2. Welke gegevens we verwerken, en waarom',
  'privacy.section2.accountHeading': 'Account en inloggen',
  'privacy.section2.accountLi1':
    'E-mailadres en gehasht wachtwoord (bij registratie met e-mail) — voor het aanmaken en beheren van je account.',
  'privacy.section2.accountLi2':
    'Naam, e-mailadres en profielfoto van je Google-account (bij inloggen via Google) — voor het aanmaken en beheren van je account.',
  'privacy.section2.accountLi3':
    'Tijdelijk gebruikers-id bij gebruik van de gastmodus (anoniem inloggen).',
  'privacy.section2.accountLi4':
    'Aantal logins en moment van laatste login — voor accountbeheer.',
  'privacy.section2.tasksHeading': 'Taken en planning',
  'privacy.section2.tasksBody':
    'Taaktitels, hiërarchie, deadlines en status die je zelf invoert, worden opgeslagen om de app te laten werken. Voltooide taken die 6 dagen niet zijn aangepast, worden automatisch gearchiveerd (niet verwijderd).',
  'privacy.section2.gcalHeading': 'Koppeling met Google Agenda (optioneel)',
  'privacy.section2.gcalBody':
    'Koppel je je Google Agenda, dan halen we met jouw toestemming agenda-items op (titel, tijdstip, locatie, omschrijving en eventuele deelnemers-e-mailadressen) en cachen we die om naast je taken te tonen. Dit gebeurt alleen na expliciete koppeling en kan op elk moment worden losgekoppeld.',
  'privacy.section2.analyticsHeading': 'Gebruiksanalyse (Firebase Analytics / GA4)',
  'privacy.section2.analyticsBody':
    'We meten een beperkt aantal gebeurtenissen (registratie/login met methode, taak aangemaakt/voltooid, klikgedrag op upgrade-meldingen) — uitsluitend nadat je hiervoor toestemming hebt gegeven via de cookiebanner. Weiger je, dan wordt er niets gemeten.',
  'privacy.section2.sentryHeading': 'Foutregistratie (Sentry)',
  'privacy.section2.sentryBody':
    'Bij een technische fout registreren we automatisch foutgegevens (foutmelding, stack trace) gekoppeld aan je gebruikers-id en e-mailadres, om storingen op te sporen en te verhelpen. Deze gegevens worden verwerkt binnen de EU.',

  'privacy.section3.heading': '3. Met wie we gegevens delen',
  'privacy.section3.body':
    'We verkopen je gegevens nooit. We schakelen verwerkers in: Google Firebase/Cloud (inloggen, database, achtergrondtaken, analytics), de Google Calendar API (alleen bij koppeling) en Sentry (foutregistratie, EU). Met elke verwerker is een verwerkersovereenkomst gesloten.',

  'privacy.section4.heading': '4. Doorgifte buiten de EER',
  'privacy.section4.body':
    'Voor zover Google gegevens buiten de EER verwerkt, gebeurt dit onder het EU-US Data Privacy Framework en/of modelcontractbepalingen. Sentry verwerkt gegevens binnen de EU.',

  'privacy.section5.heading': '5. Hoe lang we gegevens bewaren',
  'privacy.section5.li1':
    'Account- en taakgegevens: zolang je account bestaat. Voltooide taken worden na 6 dagen gearchiveerd, niet verwijderd.',
  'privacy.section5.li2':
    'Je kunt je account en alle bijbehorende gegevens (taken, voorkeuren, agenda-cache) zelf verwijderen via Instellingen → Account. Na bevestiging wordt dit direct en onomkeerbaar uitgevoerd.',
  'privacy.section5.li3':
    'Foutregistraties (Sentry) en analytics-gegevens (GA4) worden bewaard volgens de standaard bewaartermijn van die diensten.',

  'privacy.section6.heading': '6. Jouw rechten',
  'privacy.section6.body':
    'Je hebt recht op inzage, rectificatie, verwijdering en beperking van je gegevens, recht van bezwaar en recht op dataportabiliteit. Neem contact op via [contact-e-mailadres]. Ben je het niet eens met hoe we je gegevens verwerken, dan kun je een klacht indienen bij de Autoriteit Persoonsgegevens.',

  'privacy.section7.heading': '7. Cookies',
  'privacy.section7.body':
    'We gebruiken alleen analytics-cookies (Google Analytics 4), en pas nadat je hiervoor toestemming hebt gegeven via de banner die bij je eerste bezoek verschijnt. Je taalvoorkeur wordt lokaal in je browser onthouden en is geen cookie.',

  'privacy.section8.heading': '8. Wijzigingen',
  'privacy.section8.body':
    'We kunnen deze verklaring aanpassen wanneer de app verandert. De datum bovenaan geeft de laatste wijziging aan.',
};

export default nl;
